export function changeInvoiceNo(invoiceNo: string | number) {
    if (Number(invoiceNo) < 0) {
        return ' Annulée'
    }
    return invoiceNo
}